var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteimagehover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 2H10V3H14V2ZM8 2V3H3C2.44772 3 2 3.44772 2 4V7V9H4V22C4 23.1046 4.89543 24 6 24H18C19.1046 24 20 23.1046 20 22V9H22V7V4C22 3.44772 21.5523 3 21 3H16V2C16 0.895431 15.1046 0 14 0H10C8.89543 0 8 0.89543 8 2ZM10 5H14H20V7H18H6H4V5H10ZM18 9H6V22H18V9ZM8 19V12C8 11.4477 8.44772 11 9 11C9.55228 11 10 11.4477 10 12V19C10 19.5523 9.55228 20 9 20C8.44772 20 8 19.5523 8 19ZM11 12V19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19V12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12ZM14 19V12C14 11.4477 14.4477 11 15 11C15.5523 11 16 11.4477 16 12V19C16 19.5523 15.5523 20 15 20C14.4477 20 14 19.5523 14 19Z",
    fill: "#C64839"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteimagehover);
export default __webpack_public_path__ + "static/media/deleteimagehover.117b2ba9.svg";
export { ForwardRef as ReactComponent };var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteimagehover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 2H10V3H14V2ZM8 2V3H3C2.44772 3 2 3.44772 2 4V7V9H4V22C4 23.1046 4.89543 24 6 24H18C19.1046 24 20 23.1046 20 22V9H22V7V4C22 3.44772 21.5523 3 21 3H16V2C16 0.895431 15.1046 0 14 0H10C8.89543 0 8 0.89543 8 2ZM10 5H14H20V7H18H6H4V5H10ZM18 9H6V22H18V9ZM8 19V12C8 11.4477 8.44772 11 9 11C9.55228 11 10 11.4477 10 12V19C10 19.5523 9.55228 20 9 20C8.44772 20 8 19.5523 8 19ZM11 12V19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19V12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12ZM14 19V12C14 11.4477 14.4477 11 15 11C15.5523 11 16 11.4477 16 12V19C16 19.5523 15.5523 20 15 20C14.4477 20 14 19.5523 14 19Z",
    fill: "#C64839"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteimagehover);
export default __webpack_public_path__ + "static/media/deleteimagehover.117b2ba9.svg";
export { ForwardRef as ReactComponent };